import React from 'react';
import { Image } from '../common';

const members = [
  {
    name: 'Dr. Valeria Gallego',
    charge: 'Presidente',
  },
  {
    name: 'Dra. Mee Lyn Chong',
    charge: 'Vicepresidente',
  },
  {
    name: 'Dra. Mena Valles',
    charge: 'Secretaria General',
  },
  {
    name: 'Dra. María Eugenia Terán',
    charge: 'Secretaria de Organización',
  },
  {
    name: 'Dra. Delsy Calanchez',
    charge: 'Tesorera',
  },
  {
    name: 'Dra. Yilda Besereni',
    charge: 'Vocal 1',
  },
  {
    name: 'Dra. Ana Isabel Ortega',
    charge: 'Vocal 2',
  },
];

const consultiveMembers = [
  {
    name: 'Dra. Adalsa Hernández',
    charge: 'Presidente SVRID 2012-2015',
  },
  {
    name: 'Dr. Justo Bonomie',
    charge: 'Presidente SVRID 2015-2017',
  },
  {
    name: 'Dr. Juan Carlos Martínez Gómez',
    charge: 'Presidente SVRID 2017-2019',
  },
  {
    name: 'Dra. Maira Quevedo Piña',
    charge: 'Presidente 2019-2021',
  },
  {
    name: 'Dr. Francisco Penella',
    charge: 'Presidente 2021-2023',
  },
];

const honoraryMembers = [
  {
    name: 'Dra. Annika Isberg',
    country: 'Suecia',
    date: 'Noviembre 2013',
  },
  {
    name: 'Dr. Jaime San Pedro',
    country: 'Chile',
    date: 'Noviembre 2013',
  },
  {
    name: 'Dr. Hugo Aguayo',
    country: 'Perú',
    date: 'Noviembre 2013',
  },
  {
    name: 'Dr. Claudio De Freitas',
    country: 'Brasil',
    date: 'Noviembre 2013',
  },
];

function Board() {
  return (
    <div className="w-full flex flex-col flex-wrap flex-auto px-12 py-16 bg-gray-100">
      <h2 className="text-3xl uppercase font-semibold mb-4">
        Periodo 2021-2023
      </h2>
      <div className="flex flex-row flex-wrap my-4 -mx-4">
        {members.map(({ name, charge }) => (
          <div className="w-full md:w-1/2 lg:w-1/3 mb-4 p-4 py-6" key={name}>
            <div className="bg-white rounded-lg shadow-2xl w-full p-4">
              <h3 className="text-xl">{name}</h3>
              <p className="text-blue-700 text-sm">{charge}</p>
            </div>
          </div>
        ))}
      </div>
      <h2 className="text-2xl uppercase font-semibold my-4">
        Consejo Consultivo
      </h2>
      <div className="flex flex-row flex-wrap my-4 -mx-4">
        {consultiveMembers.map(({ name, charge }) => (
          <div className="w-full md:w-1/2 lg:w-1/3 mb-4 p-4 py-6" key={name}>
            <div className="bg-white rounded-lg shadow-2xl w-full p-4">
              <h3 className="text-xl">{name}</h3>
              <p className="text-blue-700 text-sm">{charge}</p>
            </div>
          </div>
        ))}
      </div>
      <h2 className="text-2xl uppercase font-semibold my-4">
        Miembros Honorarios
      </h2>
      <div className="w-full flex  flex-col md:flex-row-reverse -mx-4">
        <div className="w-full md:w-1/2 px-4">
          <Image
            alt="Miembros Honorarios"
            filename="miembros-honorarios.jpg"
            className="rounded-lg shadow-2xl"
          />
        </div>
        <table className="w-full md:w-1/2 text-center px-4 py-6 bg-white rounded-lg shadow-2xl">
          <thead>
            <tr className="border-b-2 border-blue-700">
              <th className="px-3 py-2 font-lg">Nombre</th>
              <th className="px-3 py-2 font-lg">País</th>
              <th className="px-3 py-2 font-lg">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {honoraryMembers.map(({ name, country, date }) => (
              <tr className="border-t border-blue-700" key={name}>
                <td className="px-4 py-2 text-left">{name}</td>
                <td className="px-4 py-2 ">{country}</td>
                <td className="px-4 py-2 ">{date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Board;
